export default {
    URL: 'https://api.steward.cafe/',
    SOCKET_URL: 'wss://api.steward.cafe/websocket',
    NAME: "Steward Кафе"
}